<template>
    <v-card
        width="100%"
        :style="hoverBackgroundCard"
        class="myprovet-shortcut-card elevation-0 mx-auto"
        @mouseenter="mouseEnter()"
        @mouseleave="mouseLeave()"
        @click="pageClick"
    >
        <v-card-title
            class="white--text pb-3"
        >
            <v-icon
                left
                dark
                class="shortcut-title-icon"
            >
                {{ objPage.icon }}
            </v-icon>
            <span class="shortcut-card-title dark-blue-color">{{objPage.title}}</span>
        </v-card-title>

        <v-card-text
            class="dark-blue-color mt-2"
        >
            <span class="shortcut-card-description">{{ objPage.description }}</span>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        objPage: Object
    },

    computed: {
      hoverBackgroundCard () {
        if(this.hovering) {
            return `background: linear-gradient(rgba(233, 247, 253, 0.6), rgba(233, 247, 253, 0.6))`;
        }

        return `background: linear-gradient(rgba(233, 247, 253, 1), rgba(233, 247, 253, 1))`;
      }
    },

    data () {
        return {
            hovering: false
        }
    },

    methods: {
        mouseEnter () {
            this.hovering = true;
        },

        mouseLeave () {
            this.hovering = false;
        },

        pageClick() {
            this.$inertia.visit(this.objPage.url);
        }
    },
}
</script>

<style scoped>
    .myprovet-shortcut-card {
        /* background: linear-gradient(0deg, rgba(21, 69, 121, 0.6), rgba(21, 69, 121, 0.6)), url(/storage/assets/shortcuts/order.jpg); */
        /* background-color: #154579!important; */
        background-size: cover!important;
        background-position: center!important;
        border-radius: 16px!important;
        cursor: pointer!important;
    }

    .myprovet-shortcut-card:hover {
        /* background: linear-gradient(0deg, rgba(21, 69, 121, 0.4), rgba(21, 69, 121, 0.4)), url(/storage/assets/shortcuts/order.jpg); */
        background-size: cover!important;
        background-position: center!important;
        border-radius: 16px!important;
        cursor: pointer!important;
    }

    .shortcut-title-icon {
        width: 40px;
        height: 40px;
        color: rgb(233, 247, 253);
        background: rgba(21, 69, 121, 0.8);
        border-radius: 8px;
    }

    .shortcut-card-title {
        font-size: 1.1rem;
    }

    .shortcut-card-description {
        font-size: .875rem;
    }

    @media only screen and (min-width: 1025px) {
        .myprovet-shortcut-card{
            height: 22.5vh;
        }

        .shortcut-card-title {
            font-size: 0.6rem;
        }

        .shortcut-card-description {
            margin-top: 4px;
            font-size: 0.7rem;
        }

        .shortcut-title-icon {
            width: 35px;
            height: 35px;
            border-radius: 6px;
        }
    }

    @media only screen and (max-height: 720px) and (max-width: 1350px) {
        .myprovet-shortcut-card{
            height: 25.5vh;
        }

        .shortcut-card-title {
            font-size: 0.6rem;
        }

        .shortcut-card-description {
            margin-top: 4px;
            font-size: 0.7rem;
        }

        .shortcut-title-icon {
            width: 30px;
            height: 30px;
            border-radius: 6px;
            font-size: 0.9rem;
        }
    }

    @media only screen and (min-width: 1460px) {
        .myprovet-shortcut-card{
            height: 20vh;
        }
    }

    @media only screen and (min-width: 1904px) {
        .myprovet-shortcut-card{
            height: 16.5vh;
        }

        .shortcut-card-title {
            font-size: 1.1rem;
        }

        .shortcut-card-description {
            font-size: 0.875rem;
        }

        .shortcut-title-icon {
            width: 40px;
            height: 40px;
            border-radius: 8px;
        }
    }

    /*Special case, remove/change after reworking the sidebar*/
    @media only screen and (min-width: 1264px) and (max-width: 1319px) {
        .shortcut-card-title {
            font-size: 0.56rem !important;
        }

        .shortcut-title-icon {
            width: 30px !important;
            height: 30px !important;
            border-radius: 6px !important;
            font-size: 0.9rem;
        }
    }
</style>
